import React, { useCallback, useLayoutEffect, useEffect } from 'react';
import { View } from 'react-native';
import StatusBar from 'design-system/StatusBar';
import { AppView, SettingsItemNavigate } from 'design-system';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import { IconHeart, IconTwoCoins } from 'design-system/icons';
import useColors from 'hooks/useColors';
import { useAppDispatch } from 'store/hooks';
import { getSearchResults } from 'features/invest/actions';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import { useReturnIfHasTraded } from 'features/invest/hooks/useReturnIfHasTraded';
const strings = {
    title: 'Choose your strategy',
    subtitle: 'Choose the investment approach that works best for you',
    readyMadeFunds: 'Ready-made funds',
    readyMadeFundsDescription: 'Choose from 3 expertly managed funds to keep things simple and get started',
    diy: 'Do it yourself',
    diyDescription: 'Take more control and build your own portfolio from our full range of funds',
};
const StartInvestChooseStrategyScreen = ({ navigation }) => {
    const colors = useColors();
    useReturnIfHasTraded();
    const dispatch = useAppDispatch();
    useEffect(() => {
        // prefetch the data used in the next screen
        const id = setTimeout(() => {
            dispatch(getSearchResults('seccl'));
        }, 300); // prevent fetching if leaving the screen on mount
        return () => clearTimeout(id);
    }, []);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const goToReadyMadeFunds = useCallback(() => {
        navigation.navigate('StartInvestReadyMadeFunds');
    }, []);
    const goToDiscover = useCallback(() => {
        navigation.navigate('InvestDiscover', { start: 'doItYourself' });
    }, []);
    return (<AppView avoidHeader>
      <StatusBar barStyle="dark-content"/>
      <ScreenInfoHeader title={strings.title} subTitle={strings.subtitle}/>
      <TouchableBounceCard onPress={goToReadyMadeFunds} onDark noMarginTop>
        <View pointerEvents="none">
          <SettingsItemNavigate icon={<IconHeart gradientKey={'deepPink'}/>} titleFirst title={strings.readyMadeFunds} description={strings.readyMadeFundsDescription}/>
        </View>
      </TouchableBounceCard>
      <TouchableBounceCard onPress={goToDiscover} onDark noMarginTop>
        <View pointerEvents="none">
          <SettingsItemNavigate icon={<IconTwoCoins gradientKey={'darkPurple'}/>} titleFirst title={strings.diy} description={strings.diyDescription}/>
        </View>
      </TouchableBounceCard>
    </AppView>);
};
export default StartInvestChooseStrategyScreen;
